import ReactGA from 'react-ga4';

let initialized = false;

export function initializeAnalytics() {
  const measurementId = import.meta.env.VITE_GA_MEASUREMENT_ID;

  if (measurementId && !initialized) {
    ReactGA.initialize(measurementId, {
      gaOptions: {
        cookieFlags: 'SameSite=None;Secure',
      },
    });
    initialized = true;
  }
}

export function trackPageView(path: string) {
  if (initialized) {
    ReactGA.send({ hitType: 'pageview', page: path });
  }
}

export function trackEvent(category: string, action: string, label?: string) {
  if (initialized) {
    ReactGA.event({
      category,
      action,
      label,
    });
  }
}

export function isAnalyticsInitialized() {
  return initialized;
}
